// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__sNjOH","tabs":"Settings_tabs__XjcwQ","tab":"Settings_tab__UCKqz"};